module.exports = __webpack_public_path__ + "img/24.c3dea75d.jpg";